import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/masini-london-second-hand/")({
  head: () => routeHead("/masini-london-second-hand/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/cities/london", statusCode: 301, replace: true });
  },
});
